import { useState } from 'react'
import { FaComment, FaTimes, FaPaperPlane } from 'react-icons/fa'

const ChatWidget = () => {
  const [isOpen, setIsOpen] = useState(false)
  const [message, setMessage] = useState('')
  const [isSent, setIsSent] = useState(false)

  const handleSubmit = (e) => {
    e.preventDefault()
    if (message.trim()) {
      setIsSent(true)
      setMessage('')
    }
  }

  return (
    <div className="fixed bottom-8 right-8 z-50">
      {/* Chat Button */}
      <button
        onClick={() => {
          setIsOpen(!isOpen)
          setIsSent(false)
        }}
        className="w-16 h-16 bg-gradient-to-r from-green-400 to-blue-500 rounded-full flex items-center justify-center shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105"
      >
        {isOpen ? (
          <FaTimes className="w-6 h-6 text-white" />
        ) : (
          <FaComment className="w-6 h-6 text-white" />
        )}
      </button>

      {/* Chat Window */}
      {isOpen && (
        <div className="absolute bottom-20 right-0 w-96 bg-gray-900 rounded-2xl shadow-2xl border border-gray-800 overflow-hidden transform transition-all duration-300 ease-in-out">
          {/* Header */}
          <div className="bg-gradient-to-r from-green-400/10 to-blue-500/10 p-4 border-b border-gray-800">
            <h3 className="text-lg font-bold text-white">Chat with Us</h3>
            <p className="text-sm text-gray-400">We typically reply within minutes</p>
          </div>

          {/* Chat Area */}
          <div className="p-4 h-96 flex flex-col">
            {!isSent ? (
              <>
                {/* Welcome Message */}
                <div className="bg-gray-800/50 rounded-lg p-4 mb-4 backdrop-blur-sm">
                  <p className="text-white">👋 Hi there! How can we help you today?</p>
                </div>

                {/* Message Form */}
                <form onSubmit={handleSubmit} className="mt-auto">
                  <div className="relative">
                    <textarea
                      value={message}
                      onChange={(e) => setMessage(e.target.value)}
                      placeholder="Type your message here..."
                      className="w-full bg-gray-800/50 backdrop-blur-sm border border-gray-700 rounded-lg py-3 px-4 text-white placeholder-gray-500 focus:outline-none focus:border-green-500 resize-none"
                      rows="4"
                    />
                    <button
                      type="submit"
                      className="absolute bottom-3 right-3 text-green-500 hover:text-green-400 transition-colors"
                      disabled={!message.trim()}
                    >
                      <FaPaperPlane className="w-5 h-5" />
                    </button>
                  </div>
                </form>
              </>
            ) : (
              // Thank You Message
              <div className="flex flex-col items-center justify-center h-full text-center">
                <div className="w-16 h-16 bg-green-500/20 rounded-full flex items-center justify-center mb-4">
                  <svg className="w-8 h-8 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                </div>
                <h4 className="text-xl font-bold text-white mb-2">Thanks for reaching out!</h4>
                <p className="text-gray-400 max-w-xs">
                  We've received your message and will get back to you shortly.
                </p>
              </div>
            )}
          </div>

          {/* Footer */}
          <div className="bg-gray-900 p-4 border-t border-gray-800">
            <p className="text-xs text-gray-500 text-center">
              Powered by ViralVoice Support
            </p>
          </div>
        </div>
      )}
    </div>
  )
}

export default ChatWidget 